import React from "react";

function TrendUp() {
  return (
    <>
      <svg
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.0628 3.78125V7.53125C14.0628 7.62401 14.0354 7.71471 13.9839 7.79187C13.9324 7.86902 13.8591 7.92916 13.7734 7.96467C13.6877 8.00018 13.5934 8.00946 13.5025 7.99134C13.4115 7.97322 13.3279 7.92852 13.2624 7.86289L11.719 6.31895L8.30065 9.73789C8.25712 9.78147 8.20542 9.81605 8.14851 9.83964C8.09161 9.86323 8.03061 9.87537 7.96901 9.87537C7.90741 9.87537 7.84641 9.86323 7.78951 9.83964C7.7326 9.81605 7.6809 9.78147 7.63737 9.73789L5.62526 7.72519L1.73815 11.6129C1.65019 11.7008 1.5309 11.7503 1.40651 11.7503C1.28212 11.7503 1.16283 11.7008 1.07487 11.6129C0.986913 11.5249 0.9375 11.4056 0.9375 11.2812C0.9375 11.1569 0.986913 11.0376 1.07487 10.9496L5.29362 6.73086C5.33715 6.68728 5.38885 6.6527 5.44576 6.62911C5.50266 6.60552 5.56366 6.59338 5.62526 6.59338C5.68686 6.59338 5.74786 6.60552 5.80476 6.62911C5.86167 6.6527 5.91337 6.68728 5.9569 6.73086L7.96901 8.74356L11.0563 5.65625L9.51237 4.11289C9.44674 4.04733 9.40204 3.96378 9.38392 3.8728C9.3658 3.78182 9.37509 3.68752 9.41059 3.60182C9.4461 3.51612 9.50624 3.44288 9.58339 3.39138C9.66055 3.33988 9.75125 3.31243 9.84401 3.3125H13.594C13.7183 3.3125 13.8376 3.36189 13.9255 3.44979C14.0134 3.5377 14.0628 3.65693 14.0628 3.78125Z"
          fill="#0B7C5B"
        />
      </svg>
    </>
  );
}

export default TrendUp;
